
//TODO : 
// date format
// refresh

import React from 'react';
import Moment from 'react-moment';
import { CardSmall } from '../../widgets/Cards';
//import Modal from '../../widgets/Modal';
//import Confirm from '../../widgets/Confirm';
import {connect} from 'react-redux';
//import { Form, Field} from 'react-final-form';

import { fetchReminders, fetchReminder, editReminder, newReminder, deleteReminder} from '../../../actions';

class Reminder extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            showDelete : false,
            newForm : true,
            record : null,
        };
    };

    //Initial Rendering
    componentDidMount() {
        this.props.fetchReminders(this.props.patient._id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.patient._id !== prevProps.patient._id) {
                this.props.fetchReminders(this.props.patient._id)
        }   
    }

    compareDate(a, b) {

        var key1 = a.duedate;
        var key2 = b.duetdate;
    
        if (key1 < key2) {
            return -1;
        } else if (key1 === key2) {
            return 0;
        } else {
            return 1;
        }
    }
 
    renderReminderList() {

        var list = this.props.reminders;
        var sortedList = list.sort(this.compareDate);


        return sortedList.map(reminder =>  {
         
                return (
                        <tr key={reminder._id}>
                            <td>{reminder.reason}</td>
                            <td><Moment format='DD MMM YYYY'>{reminder.duedate}</Moment></td>
                            <td>{reminder.recurring}</td>
                            <td>{reminder.provider}</td>
                            <td>{reminder.location}</td>
                            <td>{reminder.privacy}</td>
                        </tr>
                        )
        })
    }

    render() {
        return (
            <CardSmall title='Reminder List' >
                <table>
                    <thead>
                        <tr>
                            <th>Reason</th>
                            <th>Due Date</th>
                            <th>Recurring</th>
                            <th>Provider</th>
                            <th>Location</th>
                            <th>Privacy</th>
                        </tr>
                    </thead>
                    <tbody> 
                        {this.renderReminderList()}
                    </tbody> 
                </table>
            </CardSmall>
        )
    }

}

const mapStateToProps = (state) => {
    return { 
        patient : state.selectedPatient,
        reminders : Object.values(state.reminders),
        userId : state.auth.userId,
        selectedReminder : state.selectedReminder
    }
}

export default connect(mapStateToProps, {fetchReminders, fetchReminder, editReminder, newReminder, deleteReminder})(Reminder);










    








